import { Fab, Badge, Tooltip, Zoom } from "@mui/material";
import { Layers, Close } from "@mui/icons-material";

interface SidebarToggleButtonProps {
  open: boolean;
  onClick: () => void;
  badgeContent?: number;
  tooltipTitle?: string;
  show?: boolean;
}

const SidebarToggleButton = ({
  open,
  onClick,
  badgeContent = 0,
  tooltipTitle = "View sources and artifacts",
  show = true,
}: SidebarToggleButtonProps) => {
  return (
    <Zoom in={show}>
      <Tooltip title={tooltipTitle} placement="left">
        <Fab
          color="secondary"
          size="medium"
          onClick={onClick}
          sx={{
            position: "fixed",
            bottom: 16,
            right: 16,
            zIndex: (theme) => theme.zIndex.speedDial,
            transition: "all 0.3s ease",
            transform: open ? "rotate(180deg)" : "rotate(0deg)",
          }}
        >
          <Badge badgeContent={badgeContent} max={99} color="warning">
            {open ? <Close /> : <Layers />}
          </Badge>
        </Fab>
      </Tooltip>
    </Zoom>
  );
};

export default SidebarToggleButton;
